export enum RequestedInformation {
    HOURS_WORKED_PER_WEEK = "Hours worked per week",
    EMPLOYER_CONTRIBUTION_PERCENTAGE = "Percentage of premium paid by employer",
    PREMIUM_PAYMENT_TYPE = "Employee's portion of premium paid with pre-/post-tax dollars",
}